export const menuItems = [
  {
    id: 1,
    label: 'menuitems.menu.text',
    isTitle: true
  },
  {
    id: 2,
    label: 'menuitems.dashboards.text',
    icon: 'bx-home-circle',
    link: '/'
  },
  {
    id: 25,
    label: 'menuitems.admin.text',
    icon: 'mdi mdi-account-key',
    perm: ['admin.users.list', 'admin.roles.list', 'admin.languages.list', 'admin.translations.list'],
    subItems: [
      {
        id: 26,
        label: 'menuitems.admin.users',
        link: '/users',
        parentId: 25,
        perm: 'admin.users.list'
      },
      {
        id: 27,
        label: 'menuitems.admin.roles',
        link: '/roles',
        parentId: 25,
        perm: 'admin.roles.list'
      },
      {
        id: 33,
        label: 'menuitems.admin.languages',
        link: '/languages',
        parentId: 25,
        perm: 'admin.languages.list'
      },
      {
        id: 34,
        label: 'menuitems.admin.translations',
        link: '/translations',
        parentId: 25,
        perm: 'admin.translations.list'
      }
    ]
  },
  {
    id: 3,
    label: 'menuitems.apps.text',
    isTitle: true
  },
  {
    id: 4,
    label: 'menuitems.myevent.text',
    icon: 'bx-laptop',
    perm: 'event.config',
    subItems: [
      {
        id: 5,
        label: 'menuitems.myevent.list.setting',
        link: '/event/setting',
        parentId: 4,
        perm: 'event.config'
      },
      {
        id: 28,
        label: 'menuitems.myevent.list.templateEmail',
        link: '/event/emails',
        parentId: 4,
        perm: 'event.config'
      },
      {
        id: 29,
        label: 'menuitems.myevent.list.wa',
        link: '/event/wa',
        parentId: 4,
        perm: 'event.config'
      },
      {
        id: 6,
        label: 'menuitems.myevent.list.authentication',
        link: '/event/authentication',
        parentId: 4,
        perm: 'event.config'
      },
      {
        id: 7,
        label: 'menuitems.myevent.list.integration',
        link: '/event/integration',
        parentId: 4,
        perm: 'event.config'
      },
      {
        id: 8,
        label: 'menuitems.myevent.list.certificate',
        link: '/event/certificate',
        parentId: 4,
        perm: 'event.config'
      },
      {
        id: 9,
        label: 'menuitems.myevent.list.customization',
        link: '/event/customization',
        parentId: 4,
        perm: 'event.config'
      },
      {
        id: 35,
        label: 'menuitems.myevent.list.lobbybanners',
        link: '/event/lobby-banners',
        parentId: 4,
        perm: 'event.config'
      },
      {
        id: 22,
        label: 'menuitems.myevent.list.timeline',
        link: '/event/timeline',
        parentId: 4,
        perm: 'event.config'
      },
      {
        id: 24,
        label: 'menuitems.myevent.list.indication',
        link: '/event/indication',
        parentId: 4,
        perm: 'event.config'
      },
      {
        id: 18,
        label: 'menuitems.myevent.list.terms-conditions',
        link: '/event/terms-conditions',
        parentId: 4,
        perm: 'event.config'
      },
      {
        id: 32,
        label: 'menuitems.myevent.list.formbuilder',
        link: '/form-builder',
        parentId: 4,
        perm: 'formbuilder.list'
      },
      {
        id: 41,
        label: 'Listas Customizadas',
        link: '/custom-lists',
        parentId: 4,
        perm: 'event.config'
      }
    ]
  },
  {
    id: 30,
    label: 'menuitems.ecampaign.text',
    icon: 'bx bx-mail-send',
    link: '/email/campaign',
    perm: 'menu.campaigns'
  },
  {
    id: 31,
    label: 'menuitems.campaign.text',
    icon: 'bx bx-paper-plane',
    link: '/wa/campaign',
    perm: 'menu.campaigns'
  },
  {
    id: 10,
    label: 'menuitems.participants.text',
    icon: 'bxs-user-detail',
    link: '/participants',
    perm: 'participant.list'
  },
  {
    id: 11,
    label: 'menuitems.rooms.text',
    icon: 'bx-grid-alt',
    link: '/rooms',
    perm: 'room.list'
  },
  {
    id: 12,
    label: 'menuitems.speakers.text',
    icon: 'bx bxs-user-voice',
    link: '/speakers',
    perm: 'speaker.list'
  },
  {
    id: 13,
    label: 'menuitems.schedules.text',
    icon: 'bx bx-calendar-event',
    link: '/schedules',
    perm: 'schedule.list'
  },
  {
    id: 20,
    label: 'menuitems.archives.text',
    icon: 'mdi mdi-archive',
    link: '/archives',
    perm: 'archive.list'
  },
  {
    id: 23,
    label: 'menuitems.videos.text',
    icon: 'mdi mdi-video',
    perm: ['video.list', 'video.edit'],
    subItems: [
      {
        id: 36,
        label: 'menuitems.videos.list',
        link: '/videos',
        parentId: 23,
        perm: 'video.list'
      },
      {
        id: 37,
        label: 'menuitems.videos.categories',
        link: '/video-categories',
        parentId: 23,
        perm: 'video.list'
      },
      {
        id: 38,
        label: 'menuitems.videos.comments',
        link: '/video-comments',
        parentId: 23,
        perm: 'video.edit'
      }
    ]
  },
  {
    id: 14,
    label: 'menuitems.partners.text',
    icon: 'bx bxs-group',
    perm: ['partner.list'],
    subItems: [
      {
        id: 39,
        label: 'menuitems.partners.list',
        link: '/partners',
        parentId: 14,
        perm: 'partner.list'
      },
      {
        id: 40,
        label: 'menuitems.partners.categories',
        link: '/partner-categories',
        parentId: 14,
        perm: 'partner.list'
      }
    ]
  },
  {
    id: 15,
    label: 'menuitems.survey.text',
    icon: 'bx bx-happy',
    link: '/survey',
    perm: 'survey.add'
  },
  {
    id: 19,
    label: 'menuitems.gamification.text',
    icon: 'mdi mdi-trophy',
    link: '/gamification',
    perm: 'gamification.setting'
  },
  {
    id: 21,
    label: 'menuitems.raffle.text',
    icon: 'mdi mdi-gamepad-circle-down',
    link: '/raffle',
    perm: 'raffle.new'
  },
  {
    id: 16,
    label: 'menuitems.report.text',
    isTitle: true
  },
  {
    id: 17,
    label: 'menuitems.reports.text',
    icon: 'bx bxs-report',
    link: '/reports',
    perm: 'reports.participant'
  }
]
